import React from "react";
import SurveyCondensedTable from "../../../SurveyCondensedTable"
import { NumberFormat, PlaceholderFormat } from "../../../../Enums/constants"
import { observer } from "mobx-react";
import { handleFrontOfficeData, getHiddenFrontOfficeColumns } from "./FrontOfficeTableHandler";
import ibsStore from '../../../Stores/IbsSurveyStore';

const FrontOfficeTable = observer((props) => {
    let currencyPlaceHolderMilsForHeader = `|${PlaceholderFormat.CURRENCY_MILS}|`;
    let currencyPlaceHolderThousandsForHeader = `|${PlaceholderFormat.CURRENCY_THOUSANDS}|`;

    return (
        <SurveyCondensedTable tableName={"FrontOffice"}
            handleData={handleFrontOfficeData}
            headers={["TeamName", "Costs", "NumFTE", "NAV", "ReturnPct", "BMReturn", "RowID", "del"]}
            addRowBtnName={"Add New Team"}
            columns={[
                { data: 'TeamName', placeholder: 'type team name' },
                { data: 'Costs' },
                { data: 'NumFTE' },
                { data: 'NAV' },
                { data: 'ReturnPct' },
                { data: 'ReturnBmPct' },
                { data: 'RowID' },
                { data: 'del' },
            ]}
            hideExtraColumns={getHiddenFrontOfficeColumns}
            colWidths={['315px', '115px', '115px', '115px', '120px', '200px', '115px', '115px']}
            formatting={['', NumberFormat.MONEYTHOUSAND, NumberFormat.DECIMAL1, NumberFormat.DECIMAL1, NumberFormat.PERCENTAGE, NumberFormat.PERCENTAGE, 'NumberFormat.PERCENTAGE']}
            nestedHeaders={[
                ['Name of investment front office team', `Cost ex. <br/> manager fees <br/> (${currencyPlaceHolderThousandsForHeader})`, '# of FTE', `NAV <br/>${currencyPlaceHolderMilsForHeader}<br/>`, 'Net return %', `Benchmark <br/> Return %`]
            ]}
            helpText={[
                "",
                "Costs<br/><br/>attribute 100 % of costs excluding manager fees and transaction costs including:<br/><br/>(i) Salaries and benefits of front office FTE<br/><br/>(ii) General & administrative: Travel, supplies, staff education, publications and reference materials, etc.<br/><br/>(iii) Consulting and other third party fees",
                "# of Investment FTE<br/><br/>Support FTE includes staff in governance, and support services such as CEO, HR, legal, public relations, building and utilities, finance, IT, and “corporate overhead”. These staff should be attributed between investment and non-investment activities such as administering member benefits (if applicable). Only the FTE attributed to investments should be included on this survey. 100% of staff in dedicated investment organizations should be accounted for on this survey<br/><br/>Include full time permanent salaried employees and the FTE of long and short term contract individuals dedicated to your organization that are working onsite or working full-time for your fund on a project or in a role supervised by your staff. Do not include FTE at external consultants or service providers if they are not being supervised by your staff, even if they are dedicated to serving your organization. Do not include Board members.",
                "",
                "If net return is not provided, CEM will estimate it as the asset-weighted return of the underlying holdings.", "If benchmark return is not provided, CEM will estimate it as the asset-weighted return of the underlying holdings."
            ]}
            trimDropdown={false}
            includeTotalRow={ibsStore.isEnhanced}
        />
    );

});
export default FrontOfficeTable;